import { render } from "./EcuCheck.vue?vue&type=template&id=5bd96ced&scoped=true&ts=true"
import script from "./EcuCheck.vue?vue&type=script&lang=ts"
export * from "./EcuCheck.vue?vue&type=script&lang=ts"

import "./EcuCheck.vue?vue&type=style&index=0&id=5bd96ced&lang=css"
import "./EcuCheck.vue?vue&type=style&index=1&id=5bd96ced&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd96ced"]])

export default __exports__